import { Component, OnInit } from '@angular/core';
import { DwControlType } from '@devwareapps/devware-cap';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit {

  textboxControlType : DwControlType = DwControlType.Textbox;
  
  constructor() { }

  ngOnInit() {
  }

}
